import {openResourceModal} from '../../core/modalCommand';
import {reportActiveAgentModalLifecycle} from '../../core/modalLifecycle';
import {
	SITE_BACKUP_CREATE_MODAL_EVENT,
	SITE_BACKUP_DELETE_MODAL_EVENT,
	SITE_BACKUP_RESTORE_MODAL_EVENT,
	SITE_BACKUP_UPLOAD_MODAL_EVENT,
} from './events';

/**
 * Open the Create Backup form on Site Backup.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSiteBackupCreateModal(command, envelope) {
	return openResourceModal(SITE_BACKUP_CREATE_MODAL_EVENT, command, envelope);
}

/**
 * Open the Import Backup File dialog.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSiteBackupUploadModal(command, envelope) {
	return openResourceModal(SITE_BACKUP_UPLOAD_MODAL_EVENT, command, envelope);
}

/**
 * Open the restore confirmation for the resolved Site Backup row.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSiteBackupRestoreModal(command, envelope) {
	return openResourceModal(
		SITE_BACKUP_RESTORE_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Open the delete confirmation for the resolved Site Backup row(s).
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSiteBackupDeleteModal(command, envelope) {
	return openResourceModal(SITE_BACKUP_DELETE_MODAL_EVENT, command, envelope);
}

/**
 * Report a Site Backup modal outcome.
 * @param {'modal.cancelled'|'modal.saved'|'modal.failed'} eventType lifecycle event
 * @param {string|null} [errorCode] failure reason when the save did not complete
 * @return {Promise<object|null>} agent response
 */
export function reportSiteBackupModalLifecycle(eventType, errorCode = null) {
	return reportActiveAgentModalLifecycle(eventType, errorCode);
}
